const intlTelOpts = {
	preferredCountries: ['br', 'us', 'gb'],
	customContainer: 'full-width',
};

const useDeviceId = ['twilio', 'messageBird'];
const useNamespace = ['messageBird'];

const needWebhook = ['twilio'];

const radioStyle = {
	display: 'block',
	height: '40px',
	lineHeight: '30px',
};

const backgroundStyle = {
	marginTop: '0px',
	border: '1px dashed #e9e9e9',
	borderRadius: '6px',
	backgroundColor: '#fafafa',
	minHeight: '200px',
	textAlign: 'left',
	paddingTop: '10px',
};

// Fases da barra de progresso. `title` e chave do dicionario LEGADO
// (this.props.language.language[title]), nao do react-intl.
const PHASES = [
	{ title: 'step_one', icon: 'user' }, // Boas-vindas
	{ title: 'step_whatsapp', icon: 'mobile' }, // Seu WhatsApp
	{ title: 'step_seven', icon: 'link' }, // Canal aberto
	{ title: 'step_first_message', icon: 'message' }, // Primeira mensagem
];

// Sequencia de telas por API. Cada entrada: [nomeDaTela, indiceDaFaseNaBarra].
// A fase destacada e DERIVADA da tela atual - nao existe variavel de fase separada.
const SCREENS = {
	zapi: [
		['welcome', 0],
		['choice', 1],
		['connect', 1],
		['channel', 2],
		['firstMessage', 3],
	],
	meta: [
		['welcome', 0],
		['choice', 1],
		['metaConnect', 1],
		['connected', 1],
		['channel', 2],
		['firstMessage', 3],
	],
	twilio: [
		['welcome', 0],
		['token', 1],
		['phone', 1],
		['channel', 2],
		['webhook', 2],
		['firstMessage', 3],
	],
	messageBird: [
		['welcome', 0],
		['token', 1],
		['phone', 1],
		['channel', 2],
		['firstMessage', 3],
	],
};

export {
	backgroundStyle,
	intlTelOpts,
	needWebhook,
	PHASES,
	radioStyle,
	SCREENS,
	useDeviceId,
	useNamespace,
};
